// SearchNavBar.jsx
import React from 'react';

const SearchNavBar = ({ matchCount, currentMatch, navigate, hasQuery }) => {
  if (!hasQuery) return null;

  return (
    <div className="doc-search-nav">
      <span className="doc-search-count">
        {matchCount > 0
          ? `${currentMatch} / ${matchCount} matches`
          : 'No matches'}
      </span>
      <button
        className="doc-search-btn"
        onClick={() => navigate(-1)}
        disabled={matchCount === 0}
        aria-label="Previous match"
      >
        ▲
      </button>
      <button
        className="doc-search-btn"
        onClick={() => navigate(1)}
        disabled={matchCount === 0}
        aria-label="Next match"
      >
        ▼
      </button>
    </div>
  );
};

export default React.memo(SearchNavBar);
